/**
 * QUANTICA · <q-click-video>
 *
 * Hermano de q-loop-video.js, con la decision opuesta: este clip NO arranca
 * solo. Se usa donde el video es el contenido y no la decoracion.
 *
 * El elemento no reimplementa un reproductor: el <video> del HTML ya sabe
 * reproducir, pausar y buscar. Hace tres cosas y nada mas.
 *
 * 1. Cambia los controles nativos por el play de marca MIENTRAS el clip
 *    esta quieto, y se los devuelve apenas arranca. Un poster limpio con un
 *    solo boton se lee mejor que una botonera gris encima de la foto, pero
 *    una vez que el video corre la persona necesita la barra de tiempo, y
 *    esa no se dibuja a mano.
 * 2. Pausa los otros clips de la pagina cuando uno arranca. Son tres en la
 *    misma pantalla: dos sonando juntos no es una opcion.
 * 3. Al terminar vuelve al cuadro 0, que es el poster, para que la tarjeta
 *    no quede en negro.
 *
 * Sin JS el <video> conserva el atributo controls que trae del HTML: el
 * click para reproducir sigue funcionando, con la botonera del navegador.
 * Por eso los controles se apagan ACA y no en el markup, y por eso el boton
 * propio solo se muestra bajo [data-ready] (ver q-clip en critical.css).
 */
class QClickVideo extends HTMLElement {
  connectedCallback() {
    if (this.listo) return;

    this.video = this.querySelector('[data-clip-video]');
    this.boton = this.querySelector('[data-clip-play]');
    if (!this.video || !this.boton) return;

    this.listo = true;
    this.video.controls = false;
    this.setAttribute('data-ready', '');

    this.boton.addEventListener('click', () => this.reproducir());
    this.video.addEventListener('play', () => this.alArrancar());
    this.video.addEventListener('ended', () => this.alTerminar());
  }

  reproducir() {
    const p = this.video.play();
    // Un play rechazado (politica del navegador, clip que no carga) no puede
    // dejar la tarjeta a medias: vuelve al poster con controles.
    if (p && typeof p.catch === 'function') {
      p.catch(() => {
        this.removeAttribute('data-playing');
        this.video.controls = true;
      });
    }
  }

  alArrancar() {
    this.setAttribute('data-playing', '');
    this.video.controls = true;

    document.querySelectorAll('q-click-video').forEach((otra) => {
      if (otra === this) return;
      const v = otra.querySelector('[data-clip-video]');
      if (v && !v.paused) v.pause();
    });
  }

  alTerminar() {
    this.removeAttribute('data-playing');
    this.video.controls = false;
    try {
      this.video.currentTime = 0;
    } catch (e) {
      /* Safari puede rechazar el seek si el clip no quedo buscable. El
         poster no vuelve, pero el boton si: la tarjeta sigue usable. */
    }
  }
}

// Un define() repetido no da error: descarta el segundo en silencio y deja
// a la seccion sin comportamiento. Ya paso con 'q-tabs' (04/09).
if (!customElements.get('q-click-video')) {
  customElements.define('q-click-video', QClickVideo);
}
